import { BaseServiceDefinition } from './BaseService';
import { Helpers } from '@/utils/Helpers';
import { Config } from '@/utils/Config';

class ChartSummariesServiceDefinition extends BaseServiceDefinition {

    getChartSummaries(year: number): Promise<any> {
        let query = Helpers.GetFakeDataQueryString();

        if (Config.Settings.SummaryCompareWithLastYear) {
            query += (query.length ? '&' : '?') + 'compareWithLastYear=true'
        }
        
        return this.get('/api/v1/chartSummaries/' + year + query);
    }
}

export const ChartSummariesService: ChartSummariesServiceDefinition
    = new ChartSummariesServiceDefinition();